// extracted by mini-css-extract-plugin
module.exports = {"acordeonTitle":"styles_acordeonTitle__1aZgj","acordeonContent":"styles_acordeonContent__1CzBo"};